// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import './DiamondClarity.style.scss';

export class DiamondClarity extends PureComponent {
    static propTypes = {
        product: this.propTypes,
        diamond_clarity: this.propTypes
    };

    state = {
        activeClarity: {}
    }

    clarity = [
        {
            label: "FL",
            description: "FL: No inclusions or blemishes, even under 10x magnification. The rarest and most premium clarity grade.",
            className: 'fl',
            img: "/media/diamond-info-images/Clarity-fl.png"
        },
        {
            label: "IF",
            description: "IF: No inclusions, only minor surface blemishes. Exceptionally clean and luxurious.",
            className: 'if',
            img: "/media/diamond-info-images/Clarity-if.png"
        },
        {
            label: "VVS1",
            description: "IF: No inclusions, only minor surface blemishes. Exceptionally clean and luxurious.",
            className: 'vvs',
            img: "/media/diamond-info-images/Clarity-vvs1.png"
        },
        {
            label: "VVS2",
            description: "VVS2: Slightly more inclusions than VVS1, but still very hard to detect under 10x magnification. Excellent clarity.",
            className: 'vvs',
            img: "/media/diamond-info-images/Clarity-vvs2.png"
        },
        {
            label: "VS1",
            description: "VS1: Minor inclusions visible under 10x magnification but not to the naked eye. Great value for eye-clean diamonds.",
            className: 'vs',
            img: "/media/diamond-info-images/Clarity-vs1.png"
        },
        {
            label: "VS2",
            description: "VS2: Slightly more inclusions than VS1, but still eye-clean in most settings. A popular choice for balance and value.",
            className: 'vs',
            img: "/media/diamond-info-images/Clarity-vs2.png"
        },
        {
            label: "SI1",
            description: "SI1: Slightly Included. Inclusions are easy to see under 10x magnification. Some are visible to the naked eye.",
            className: 'sl',
            img: "/media/diamond-info-images/Clarity-si1.png"
        },
        {
            label: "SI2",
            description: "SI2: More noticeable inclusions visible to the human eye, but still a good choice for those prioritizing size or budget.",
            className: 'sl',
            img: "/media/diamond-info-images/Clarity-si2.png"
        },
        // {
        //     label: "SI3",
        //     description: "There is a chance of visibility to naked eye, more inclusions compared to SI1.",
        //     className: 'sl'
        // },
        // {
        //     label: "I1",
        //     description: "I1 I2 I3",
        //     className: 'l'
        // },
        // { <span>{value?.label}</s
        //     label: "I2",
        //     description: "I1 I2 I3",
        //     className: 'l'
        // },
        // {
        //     label: "I3",
        //     description: "I1 I2 I3",
        //     className: 'l'
        // }
    ];

    componentDidMount() {
        const { diamond_clarity } = this.props;

        const clarity = this.clarity?.find((value) => (
            value?.label?.toLowerCase() === diamond_clarity?.toLowerCase()
        ));

        this.setState({
            activeClarity: clarity ? clarity : this.clarity[0]
        });
    }

    changeDiamondInfo = (value) => {
        this.setState({
            activeClarity: value
        });
    }

    render() {
        const {
            diamond_clarity
        } = this.props;

        const { activeClarity } = this.state;

        return (
            <>
                <div className='DiamondDetails-ContentSection DimondDetails-Clarity-card'>
                    {/* <svg width="199" height="200" viewBox="0 0 199 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_2677_15216" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="199" height="200">
                            <rect x="0.208984" y="0.766602" width="198.62" height="198.62" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_2677_15216)">
                            <path d="M99.5191 149.584C66.6934 149.584 40.0117 122.86 40.0117 90.0768C40.0117 57.294 66.6934 30.5693 99.5191 30.5693C132.345 30.5693 159.027 57.251 159.027 90.0768C159.027 122.903 132.345 149.584 99.5191 149.584ZM77.9934 144.171C84.739 146.834 92.129 148.338 99.7769 148.295L85.0827 129.906L78.0363 144.171H77.9934ZM116.834 130.121L101.453 148.252C108.757 147.994 115.717 146.448 122.076 143.741L116.834 130.121ZM85.985 128.961L100.636 147.221L116.018 129.09L100.55 122.817L85.985 128.918V128.961ZM60.0337 132.828C64.9318 137.339 70.6033 141.034 76.7903 143.655L83.7937 129.519L60.0337 132.828ZM118.037 129.605L123.279 143.225C129.466 140.432 135.095 136.609 139.95 131.925L118.037 129.605ZM46.2847 113.622C49.2923 120.453 53.5889 126.555 58.8736 131.71L62.0531 107.908L46.2847 113.622ZM63.3421 107.822L60.1626 131.496L84.0085 128.187L77.9504 113.708L63.3421 107.779V107.822ZM117.951 128.316L139.993 130.636L138.274 107.005L124.181 112.934L117.951 128.316ZM139.606 107.048L141.325 130.507C146.266 125.395 150.305 119.379 153.14 112.72L139.606 107.005V107.048ZM102.226 122.172L116.705 128.058L122.549 113.665L102.226 122.215V122.172ZM79.626 114.395L85.2545 127.844L98.7887 122.172L79.5831 114.395H79.626ZM78.9386 112.72L100.507 121.442L123.193 111.903L131.743 90.7642L122.42 68.5939L100.078 59.5282L79.0675 68.3361L69.8299 91.1079L78.8956 112.677L78.9386 112.72ZM41.3007 91.5806C41.4726 98.9277 43.0623 105.974 45.7262 112.419L61.4516 106.704L41.3007 91.5806ZM63.6428 106.533L77.22 112.032L69.1854 92.8695L63.6428 106.533ZM140.122 105.888L153.613 111.56C156.148 105.244 157.566 98.3691 157.738 91.2368L140.122 105.888ZM132.474 92.4828L124.869 111.259L138.016 105.716L132.474 92.4828ZM42.3748 90.7642L62.5257 105.888L68.455 91.1939L61.9672 75.7692L42.3748 90.7642ZM133.161 90.7642L139.133 104.986L156.749 90.2916L139.262 75.6403L133.161 90.7212V90.7642ZM45.941 67.305C42.9763 74.2654 41.3007 81.9133 41.3007 89.9479L61.0649 74.8669L45.898 67.305H45.941ZM63.1272 75.1247L69.1854 89.5182L77.4348 69.1095L63.1272 75.1247ZM140.251 74.824L157.695 89.4323C157.609 82.4289 156.32 75.6833 153.957 69.4962L140.251 74.824ZM124.138 69.3244L132.431 89.0885L138.145 74.9958L124.138 69.3244ZM59.4322 49.4313L62.8265 73.8357L78.1222 67.4339L83.8796 53.2122L59.4322 49.4742V49.4313ZM123.451 67.6487L138.489 73.7068L141.024 50.6343L117.178 52.6537L123.451 67.6057V67.6487ZM142.313 50.6343L139.778 73.6209L153.527 68.2932C150.863 61.7194 147.039 55.7472 142.313 50.6343ZM46.4566 66.1449L61.4945 73.6639L58.1003 49.2164C53.2881 54.1145 49.3353 59.8289 46.4566 66.1449ZM101.796 58.8837L121.775 66.9612L115.889 52.9544L101.796 58.8837ZM85.1256 53.513 <span>{value?.label}</sL79.7549 66.7034L98.402 58.8837L85.1256 53.513ZM85.7701 52.3959L100.121 58.1962L115.202 51.8803L99.1754 33.0184L85.7701 52.3959ZM59.2174 48.0993L83.7937 51.8803L78.0363 35.983C70.99 38.7758 64.5881 42.9434 59.2174 48.1423V48.0993ZM122.721 36.6705L117.178 51.3647L141.067 49.3453C135.868 44.0176 129.638 39.6781 122.721 36.6705ZM79.2394 35.5104L84.9538 51.2788L98.402 31.8583C91.6994 31.9872 85.2116 33.2762 79.2394 35.4674V35.5104ZM99.9058 31.8583L116.018 50.8491L121.561 36.1549C114.858 33.4051 107.554 31.8583 99.9058 31.8153V31.8583Z" fill="#010101" />
                            <path d="M76.5289 99.0995V98.9277C76.0563 98.7988 75.5837 98.8417 75.1111 98.7988H76.5289C76.5289 98.3691 76.2282 98.0254 75.7985 98.0254C75.3689 98.0254 75.0681 98.3262 75.0681 98.7558V98.8417C75.0681 99.2714 75.24 99.7011 75.5407 100.002C75.7985 100.303 76.2282 100.389 76.5289 100.131C76.8297 99.8729 76.9156 99.4433 76.6578 99.0995C76.6149 99.0566 76.5289 98.9706 76.486 98.8847C76.486 98.9277 76.486 98.9706 76.486 99.0136C76.486 99.0136 76.486 98.9277 76.486 98.8847V98.7558C76.486 98.3691 76.1852 98.0254 75.7556 98.0254C75.3259 98.0254 75.0251 98.3262 75.0251 98.7558L76.443 98.7988C75.8845 98.8417 74.8962 98.455 75.0251 99.1425C75.0251 99.5292 75.3259 99.83 75.7556 99.83C76.1852 99.83 76.486 99.5292 76.486 99.1425" fill="#010101" />
                            <path d="M66.4394 114.18C66.4394 114.18 66.3535 114.61 66.3105 114.782C66.1816 115.04 66.3105 115.34 66.6113 115.469C66.8691 115.598 67.1698 115.469 67.2987 115.168C67.4706 114.911 67.3847 114.567 67.5136 114.309C67.5565 114.008 67.3847 113.751 67.0839 113.708C66.7831 113.665 66.5253 113.88 66.4824 114.137" fill="#010101" />
                            <path d="M69.4883 120.153C69.3594 120.453 69.2734 120.797 69.2734 121.184C69.2734 121.485 69.4883 121.699 69.789 121.699C70.0898 121.699 70.3046 121.442 70.3046 121.184C70.3046 120.969 70.3905 120.754 70.4335 120.539C70.5194 120.282 70.3905 119.981 70.1328 119.852C69.875 119.766 69.5742 119.852 69.4453 120.153" fill="#010101" />
                        </g>
                    </svg> */}

                    <img src={activeClarity?.img} />


                    <div className='DiamondDetails-ListOf'>
                        {
                            this.clarity?.map((value, index) => (
                                <div
                                    className={'DiamondDetails-ListOf_item' + (value?.label?.toLowerCase() === activeClarity?.label?.toLowerCase() ? " DiamondDetails-ListOf_item_active" : "")}
                                    key={index}
                                    onClick={() => this.changeDiamondInfo(value)}
                                >
                                    <span>{value?.label}</span>
                                </div>
                            ))
                        }
                    </div>

                    <div className='DiamondDetails-ListOfContent'>
                        <p>{activeClarity?.description}</p>
                    </div>
                </div>
            </>
        );
    }
}

export default DiamondClarity;
